module.exports = __webpack_public_path__ + "static/img/home_banner.adee374.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_banner.jpg
// module id = /csU
// module chunks = 1